import React from 'react';
import NotFound from './notfound';
import TaxonomyArchive from './taxonomyarchive';
import Error from './error';
import LoadingIndicator from './loadingindicator';
import Post from './post';

export default {
    NotFound,
    TaxonomyArchive,
    Error,
    LoadingIndicator,
    Post,
    Archive: React.Fragment // TODO: implement
};

